export default /* glsl */`
uniform sampler2D tMap;

varying vec2 vUv;

varying vec2 vUv0;
varying vec2 vUv1;
varying vec2 vUv2;
varying vec2 vUv3;
varying vec2 vUv4;
varying vec2 vUv5;

void main() {

	const vec2 threshold = vec2(EDGE_THRESHOLD);

	// Calculate color deltas.
	vec4 delta;
	vec3 c = texture2D(tMap, vUv).rgb;

	vec3 cLeft = texture2D(tMap, vUv0).rgb;
	vec3 t = abs(c - cLeft);
	delta.x = max(max(t.r, t.g), t.b);

	vec3 cTop = texture2D(tMap, vUv1).rgb;
	t = abs(c - cTop);
	delta.y = max(max(t.r, t.g), t.b);

	// Use a threshold to detect significant color edges.
	vec2 edges = step(threshold, delta.xy);

	// Discard if there is no edge.
	if(dot(edges, vec2(1.0)) == 0.0) {

		discard;

	}

	// Calculate right and bottom deltas.
	vec3 cRight = texture2D(tMap, vUv2).rgb;
	t = abs(c - cRight);
	delta.z = max(max(t.r, t.g), t.b);

	vec3 cBottom = texture2D(tMap, vUv3).rgb;
	t = abs(c - cBottom);
	delta.w = max(max(t.r, t.g), t.b);

	// Calculate the maximum delta in the direct neighborhood.
	float maxDelta = max(max(max(delta.x, delta.y), delta.z), delta.w);

	// Calculate left-left and top-top deltas.
	vec3 cLeftLeft = texture2D(tMap, vUv4).rgb;
	t = abs(c - cLeftLeft);
	delta.z = max(max(t.r, t.g), t.b);

	vec3 cTopTop = texture2D(tMap, vUv5).rgb;
	t = abs(c - cTopTop);
	delta.w = max(max(t.r, t.g), t.b);

	// Calculate the final maximum delta.
	maxDelta = max(max(maxDelta, delta.z), delta.w);

	// Local contrast adaptation.
	edges *= step(maxDelta, LOCAL_CONTRAST_ADAPTATION_FACTOR * delta.xy);

    gl_FragColor = vec4(edges, 0.0, 1.0);
}`;
